<template>
  <div class="mb-3 hover-actions position-relative">
    <EditForm v-if="editForm" :item="item" @closeForm="editForm = false" />
    <div v-else class="sidebar-card" :class="{ 'pulse-shadow': unread }" @focus="unread ? markPostRead(item.id) : null"
      @mouseover="unread ? markPostRead(item.id) : null">
      <div v-if="itemOwner || !itemDeleted || didDeleteItem">
        <div class="p-3 rounded-top" :class="messageColor">
          <AVIcon v-if="itemDeleted" icon="eye-slash" class="mb-2 float-end" v-tooltip="$t('js.tooltips.only_visible_to_you')" />
          <h5>
          <AVIcon icon="file-signature" />
            {{ item.target_slide.deleted
                ? $t("js.sidebar.general.deleted", { resource: $t("js.sidebar.general.resource.slide") })
                : item.target_slide.title[firstAvailableLocale] }}
          </h5>
          <span>
            {{ $t("js.sidebar.general.by") }}
            {{ item.owner.deleted
              ? $t("js.sidebar.general.deleted", { resource: $t(`js.sidebar.general.resource.${item.owner.type}`) })
              : item.owner.name
            }}</span>
        </div>
        <div class="p-3 text-white" :class="itemDeleted ? 'text-white-50' : 'text-white'" style="white-space: pre-wrap; overflow-wrap: break-word;">{{ item.message }}</div>
      </div>
      <div v-if="itemDeleted" class="d-flex align-items-center justify-content-center p-3 small text-white-50">
        <AVIcon icon="trash-alt" class="pe-3" />
        <span>{{ $t("js.sidebar.amendments.deleted_by") }} {{ $t(`js.sidebar.general.deleted_by.${item.deleted_by.type}`) }}</span>
      </div>
      <PostActions :post="item" :editing="editForm" @prepareEdit="editForm = true" @cancelEdit="editForm = false"/>
    </div>
    <div class="d-flex justify-content-between small text-white-50">
      <span>
        {{ item.owner.deleted
          ? $t("js.sidebar.general.deleted", {resource: $t(`js.sidebar.general.resource.${item.owner.type}`)})
          : item.owner.name
        }}</span>
      <span v-if="item.edited && !itemDeleted">{{ $t("js.sidebar.general.edited") }}</span>
      <time :datetime="item.created_at">{{ $d(item.created_at, "long") }}</time>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapActions, mapState } from "pinia";
import PostActions from "../PostActions.vue";
import EditForm from "./EditForm.vue";
import { useSharedStore } from "@/entrypoints/stores/shared";
import { usePresentationStore } from "@/entrypoints/stores/presentation";
import { useVotingModulesStore } from "@/entrypoints/stores/voting_modules";
import type { PropType, UserPost, Slide } from "@/types";

export default defineComponent({
  name: "Amendment",
  components: { EditForm, PostActions },
  props: {
    item: {
      type: Object as PropType<UserPost>,
      required: true,
    },
  },
  data() {
    return {
      editForm: false,
      read: false,
    }
  },
  computed: {
    ...mapState(usePresentationStore, ["slides"]),
    ...mapState(useSharedStore, ["firstAvailableLocale"]),
    ...mapState(useVotingModulesStore, ["chatUser"]),
    unread() {
      return this.item.unread;
    },
    itemOwner() {
      return this.item.owner.id === this.chatUser.id && this.item.owner.type === this.chatUser.type;
    },
    ballotSlides() {
      return this.slides.filter((s: Slide) => s.type === "Slides::BallotSlide");
    },
    itemDeleted() {
      return this.item.deleted_by && this.item.deleted_by.id && this.item.deleted_by.type;
    },
    messageColor() {
      return this.itemDeleted ? "text-white-50 bg-light-transparent" : "bg-theme";
    },
    didDeleteItem() {
      return this.item.deleted_by.id
        && this.item.deleted_by.type
        && this.chatUser.type === this.item.deleted_by.type
        && this.item.deleted_by.id === this.chatUser.id;
    },
  },
  methods: {
    ...mapActions(useVotingModulesStore, ["markPostRead"]),
  }
});
</script>
